import { ConflictHandler, DISCARD } from 'aws-amplify/datastore';
import { Bulletin, BulletinStatus } from '@alucio/aws-beacon-amplify/src/models';

const MUTABLE_FIELDS = ['title', 'content', 'status', 'updatedAt', 'updatedBy'] as const;

export function createBulletinConflictHandler(fallback: ConflictHandler): ConflictHandler {
  return (conflict) => {
    if (!Object.is(conflict.modelConstructor, Bulletin)) return fallback(conflict);
    const local: Readonly<Record<string, unknown>> = conflict.localModel;
    const remote: Readonly<Record<string, unknown>> = conflict.remoteModel;
    if (
      remote._deleted ||
      remote.status === BulletinStatus.DELETED ||
      (remote.status === BulletinStatus.ACTIVE && local.status === BulletinStatus.DRAFT) ||
      typeof remote._version !== 'number' ||
      typeof remote.id !== 'string'
    ) {
      return DISCARD;
    }
    const retry: Record<string, unknown> = { id: remote.id, _version: remote._version };
    for (const field of MUTABLE_FIELDS) {
      if (local[field] !== null && local[field] !== undefined) retry[field] = local[field];
    }
    if (remote.status === BulletinStatus.DRAFT && local.status === BulletinStatus.ACTIVE &&
      typeof local.publishedAt === 'string' && local.publishedAt) {
      retry.publishedAt = local.publishedAt;
    }
    // DataStore normalizes omitted patch fields to null. Retry the patch directly;
    // reconstructing a model adds nulls and includes the immutable tenantId field.
    return retry;
  };
}
